import { BookMarkedIcon, ClipboardCheckIcon, CompassIcon, GlobeIcon, SparklesIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  value: string;
  description: string;
  benefit: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: '150 Geology Classroom Activities',
    value: 'USD 14',
    description:
      '150 ready-to-use activity ideas covering minerals, rocks, plate tectonics, earthquakes, volcanoes, fossils, geological time, structures, landscapes, and natural resources. Organized by difficulty level and topic.',
    benefit: 'Materials already designed for your classroom: saves hours every quarter.',
    icon: SparklesIcon,
  },
  {
    number: '02',
    title: 'Geology Assessment Collection: 60 Ready-to-Use Instruments',
    value: 'USD 14',
    description:
      'Diagnostic assessments, progress activities, multiple-choice questions, true/false exercises, short-answer prompts, extended-response questions, concept-application activities, case-based assessments, rubrics, and scoring criteria.',
    benefit: 'Never build an exam from scratch under pressure again.',
    icon: ClipboardCheckIcon,
  },
  {
    number: '03',
    title: '50 Geology Projects & STEM Challenges',
    value: 'USD 14',
    description:
      '50 fully explained project ideas connecting geology with science, technology, engineering, and mathematics. Each includes driving questions, objectives, development stages, expected outcomes, and assessment criteria.',
    benefit: 'Your students finish the year with real geological investigation projects.',
    icon: CompassIcon,
  },
  {
    number: '04',
    title: "Geology Teacher's Concept & Terminology Guide: 500 Essential Concepts",
    value: 'USD 14',
    description:
      'Teacher-focused reference containing 500 essential geology terms with clear definitions, contextual explanations, classroom examples, concept connections, common student misconceptions, discussion questions, and teaching recommendations.',
    benefit: 'Project it in class and your students instantly understand complex geological concepts.',
    icon: BookMarkedIcon,
  },
  {
    number: '05',
    title: '100 Global Geology Case Studies',
    value: 'USD 14',
    description:
      'One hundred written real-world cases showing how geological processes affect communities, ecosystems, resources, and infrastructure worldwide: earthquakes, eruptions, tsunamis, landslides, coastal erosion, groundwater, mining, fossil discoveries, engineering projects, contamination, and conservation. Each includes context, geological explanation, consequences, discussion questions, and classroom applications.',
    benefit: 'Your students learn by analyzing authentic geological challenges and solutions.',
    icon: GlobeIcon,
    wide: true,
  },
];
